import { ReactComponent as info } from '../../../assets/icons/info.svg';
import { ReactComponent as category } from '../../../assets/icons/category.svg';
import { ReactComponent as arrowRight } from '../../../assets/icons/arrow_right.svg';
import { ReactComponent as profile } from '../../../assets/icons/profile.svg';
import { ReactComponent as logout } from '../../../assets/icons/logout.svg';
import { ReactComponent as add } from '../../../assets/icons/add.svg';
import { ReactComponent as search } from '../../../assets/icons/search.svg';
import { ReactComponent as checked } from '../../../assets/icons/checked.svg';
import { ReactComponent as check } from '../../../assets/icons/check.svg';
import { ReactComponent as uncheck } from '../../../assets/icons/uncheck.svg';
import { ReactComponent as infoCircle } from '../../../assets/icons/info-circle.svg';
import { ReactComponent as statistic } from '../../../assets/icons/statistic.svg';
import { ReactComponent as chevronRight } from '../../../assets/icons/chevron_right.svg';
import { ReactComponent as plus } from '../../../assets/icons/plus.svg';
import { ReactComponent as minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as edit } from '../../../assets/icons/edit.svg';
import { ReactComponent as deleteIcon } from '../../../assets/icons/delete.svg';
import { ReactComponent as researchIcon } from '../../../assets/icons/research.svg';
import { ReactComponent as loanIcon } from '../../../assets/icons/loan.svg';
import { ReactComponent as optimizationIcon } from '../../../assets/icons/optimization.svg';
import { ReactComponent as securityIcon } from '../../../assets/icons/security.svg';
import { ReactComponent as moneyIcon } from '../../../assets/icons/money.svg';
import { ReactComponent as searchEngineIcon } from '../../../assets/icons/search-engine.svg';
import { ReactComponent as retailIcon } from '../../../assets/icons/retail.svg';
import { ReactComponent as statisticModuleIcon } from '../../../assets/icons/statistic-module.svg';
import { ReactComponent as dropdownIcon } from '../../../assets/icons/dropdown.svg';
import { ReactComponent as arrowForwardIos } from '../../../assets/icons/arrow_forward_ios.svg';
import { ReactComponent as arrowRightLink } from '../../../assets/icons/arrow_right_link.svg';
import { ReactComponent as paperPlus } from '../../../assets/icons/paper-plus.svg';
import { ReactComponent as tickSquare } from '../../../assets/icons/tick-square.svg';
import { ReactComponent as paper } from '../../../assets/icons/paper.svg';
import { ReactComponent as paperUpload } from '../../../assets/icons/paper-upload.svg';
import { ReactComponent as upload } from '../../../assets/icons/upload.svg';
import { ReactComponent as clear } from '../../../assets/icons/clear.svg';
import { ReactComponent as work } from '../../../assets/icons/work.svg';
import { ReactComponent as setting } from '../../../assets/icons/setting.svg';
import { ReactComponent as danger } from '../../../assets/icons/danger.svg';
import { ReactComponent as location } from '../../../assets/icons/location.svg';
import { ReactComponent as arrowUpCircle } from '../../../assets/icons/arrow-up-circle.svg';
import { ReactComponent as more } from '../../../assets/icons/more.svg';
import { ReactComponent as refresh } from '../../../assets/icons/refresh.svg';
import { ReactComponent as openNew } from '../../../assets/icons/open-new.svg';
import { ReactComponent as doubleArrow } from '../../../assets/icons/double-arrow.svg';
import { ReactComponent as download } from '../../../assets/icons/download.svg';
import {ReactComponent as arrowDown} from '../../../assets/icons/arrow_down.svg'
import {ReactComponent as ellipse} from '../../../assets/icons/ellipse.svg'
import {ReactComponent as usFlag} from '../../../assets/icons/us.svg'
import {ReactComponent as caFlag} from '../../../assets/icons/ca.svg'


export const InfoIcon = info;
export const CategoryIcon = category;
export const ArrowRightIcon = arrowRight;
export const ProfileIcon = profile;
export const LogoutIcon = logout;
export const AddIcon = add;
export const SearchIcon = search;
export const CheckedIcon = checked;
export const CheckIcon = check;
export const UncheckIcon = uncheck;
export const InfoCircleIcon = infoCircle;
export const StatisticIcon = statistic;
export const ChevronRight = chevronRight;
export const PlusIcon = plus;
export const MinusIcon = minus;
export const EditIcon = edit;
export const DeleteIcon = deleteIcon;
export const ResearchIcon = researchIcon;
export const LoanIcon = loanIcon;
export const OptimizationIcon = optimizationIcon;
export const SecurityIcon = securityIcon;
export const MoneyIcon = moneyIcon;
export const SearchEngineIcon = searchEngineIcon;
export const RetailIcon = retailIcon;
export const StatisticModuleIcon = statisticModuleIcon;
export const DropdownIcon = dropdownIcon;
export const ArrowForwardIcon = arrowForwardIos;
export const ArrowRightLink = arrowRightLink;
export const PaperPlusIcon = paperPlus;
export const TickSquareIcon = tickSquare;
export const PaperIcon = paper;
export const PaperUploadIcon = paperUpload;
export const UploadIcon = upload;
export const ClearIcon = clear;
export const WorkIcon = work;
export const SettingIcon = setting;
export const DangerIcon = danger;
export const LocationIcon = location;
export const ArrowUpCircleIcon = arrowUpCircle;
export const MoreIcon = more;
export const RefreshIcon = refresh;
export const OpenNewIcon = openNew;
export const DoubleArrowIcon = doubleArrow;
export const DownloadIcon = download;
export const ArrowDownIcon = arrowDown;
export const EllipseIcon = ellipse;
export const UsFlag = usFlag;
export const CaFlag = caFlag;